import { z } from "zod/v4";

import {
  AgencyCustomerDtoSchema,
  CreateAgencyCustomerDtoSchema,
} from "../../../dtos/agency-customers";

export const CreateAgencyCustomerRequestBodySchema = z.object({
  customer: CreateAgencyCustomerDtoSchema,
});

export type CreateAgencyCustomerRequestBodyType = z.infer<
  typeof CreateAgencyCustomerRequestBodySchema
>;

export const CreateAgencyCustomerResponseBodySchema = z.object({
  customer: AgencyCustomerDtoSchema,
});

export type CreateAgencyCustomerResponseBodyType = z.infer<
  typeof CreateAgencyCustomerResponseBodySchema
>;
